import type { InterventionSectionSaveBarWrapperProps } from "./intervention-section-save-bar.type";

import InterventionSectionSaveBar from "./intervention-section-save-bar.component";
import { useInterventionSectionSaveBarWrapper } from "./intervention-section-save-bar.hook";

const InterventionSectionSaveBarWrapper = ({
  screenSize,
  ...componentProps
}: InterventionSectionSaveBarWrapperProps) => {
  const { showSaveBar, currentScreenSize } =
    useInterventionSectionSaveBarWrapper(screenSize);

  if (!showSaveBar) return null;

  return (
    <div
      className={`intervention-section-save-bar -${currentScreenSize}-screen`}
    >
      <InterventionSectionSaveBar {...componentProps} />
    </div>
  );
};

export default InterventionSectionSaveBarWrapper;
